<template>
  <v-data-table :headers="headers" :items="filteredTemplates" sort-by="name">
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          label="Busca"
          v-model="filter"
          outlined
          dense
          hide-details
          clearable
          append-icon="eva-search-outline"
        />

        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" fullscreen @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Novo protocolo
            </v-btn>
          </template>

          <ConfigPrescriptionForm
            :template="editedItem"
            :refreshList="refreshList"
            :formTitle="formTitle"
            :closeDialog="close"
          />
          <!-- <ConfigPrescriptionForm /> -->
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_template"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_template"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há facilitadores de Histórico da Moléstia Atual cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
import ConfigPrescriptionForm from "@/components/config/template/prescription/form/index.vue";

export default {
  name: "TemplatePrescriptionConfig",
  components: {
    ConfigPrescriptionForm,
  },
  data() {
    return {
      dialog: null,
      editedItem: {
        id: "",
        name: "",
        items: [
          {
            id: "",
            buildingInformation: {
              special_control: false,
              prescription_items: [],
              prescription_guidances: [],
            },
          },
        ],
      },
      defaultItem: {
        id: "",
        name: "",
        items: [
          {
            id: "",
            buildingInformation: {
              special_control: false,
              prescription_items: [],
              prescription_guidances: [],
            },
          },
        ],
      },
      editedIndex: -1,
      headers: [
        { text: "Nome", value: "name" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
      templates: [],
      filter: "",
    };
  },
  apollo: {
    templates: {
      query: require("@/graphql/template/templates.gql"),
      variables() {
        return {
          templateType: "prescription",
        };
      },
      pollInterval: 20000,
    },
  },
  computed: {
    filteredTemplates() {
      let templates = this.lodash.orderBy(
        this.templates,
        (e) => {
          return e.name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        },
        ["asc"]
      );

      if (this.filter) {
        templates = this.lodash.filter(
          templates,
          function (e) {
            return e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return templates;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Novo protocolo" : "Editar protocolo";
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.filteredTemplates.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Você realmente deseja deletar protocolo?")) {
        this.apolloMutate({
          mutation: require("@/graphql/template/delete_template.gql"),
          variables: {
            templateId: item.id,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro deletado com sucesso.",
            type: "success",
          });
        });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    refreshList() {
      return this.$apollo.queries.templates.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
